module.exports = __webpack_public_path__ + "static/pi9-81947cfafd632038cb1bc05dee711ec7.png";